import React, { useEffect, useState, useContext } from 'react'
import { Link } from 'gatsby'
import { HamburgerElastic } from 'react-animated-burgers'
import { Context } from '../../../context/app-context'
import imgLogoActitity from './../../../assets/images/logoActividad.png'
import { LOCALE } from '../../../constants/activity-constants'

import './navMenu.scss'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

export default function NavMenu({ isMobile }) {
  const [isOpen, setIsOpen] = useState(false)
  const { dispatch } = useContext(Context)

  const handleCloseMenu = e => {
    e.preventDefault()
    setIsOpen(() => !isOpen)
  }

  const NAV_LINKS = [
    { to: '/como-participar', label: '¿Cómo participar?' },
    { to: '/juegos', label: 'Jugar' },
    // { to: '/top', label: 'Top' },
    {
      type: 'event',
      to: '#',
      label: 'Términos y condiciones',
      onClick: () => {
        dispatch({
          type: 'set',
          payload: {
            modalActive: {
              type: 'modalTerms',
              props: {
                close: () => {
                  dispatch({
                    type: 'set',
                    payload: {
                      modalActive: null,
                    },
                  })
                },
              },
            },
          },
        })
      },
    },
  ].filter(item => {
    return LOCALE === 'es-BO' ? item.label !== 'TOP' : true
  })

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'initial'
  }, [isOpen])

  return (
    <>
      {isMobile ? (
        <>
          <div
            className={`f-personajes-nav-menu-btn-burguer f-personajes-nav-menu-btn-burguer--${
              isOpen ? 'open' : 'close'
            }`}
          >
            <HamburgerElastic
              isActive={isOpen}
              toggleButton={handleCloseMenu}
              barColor={isMobile ? 'white' : isOpen ? '#fff080' : '#8436c7'}
            />
          </div>
          <div
            className={`f-personajes-nav-menu ${
              isOpen
                ? 'f-personajes-nav-menu--open'
                : 'f-personajes-nav-menu--close'
            }`}
          >
            <div className="f-personajes-nav-menu__container">
              <Link
                className={`f-personajes-nav-menu__links__home`}
                activeClassName="active"
                to="/"
              >
                <img src={imgLogoActitity} alt="Logo de la actividad" />
              </Link>
              <ul className="f-personajes-nav-menu__links">
                {NAV_LINKS.map(item => {
                  return (
                    <li
                      key={JSON.stringify(item)}
                      className="f-personajes-nav-menu__links__item"
                    >
                      <Link
                        to={item.to}
                        onClick={() => {
                          if (item.type === 'event') item.onClick()
                          pushEventDataLayer('Personajes :: Menú', 'Click', item.label)

                        }}
                        className={`f-personajes-nav-menu__links__item__link`}
                        activeClassName="active"
                      >
                        {item.label}
                      </Link>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </>
      ) : (
        <div className='f-personajes-nav-menu--desktop'>
          <ul className='f-personajes-nav-menu__links__container'>
            <li className='f-personajes-nav-menu__links__item'>
              <Link
                to={'/'}
                className={`f-personajes-nav-menu__links__item__a`}
                activeClassName='active'
              >
                Inicio
              </Link>
            </li>

            {NAV_LINKS.map(item => {
              return (
                <li
                  key={JSON.stringify(item)}
                  className='f-personajes-nav-menu__links__item'
                >
                  <Link
                    to={item.to}
                    onClick={() => {
                      if (item.type === 'event') item.onClick()
                      pushEventDataLayer('Personajes :: Menú ', 'Click', item.label)

                    }}
                    className={`f-personajes-nav-menu__links__item__a`}
                    activeClassName='active'
                  >
                    {item.label}
                  </Link>
                </li>
              )
            })}
          </ul>
        </div>
      )}
    </>
  )
}
